<div class="cover-container">
  <header>
    <div>
      <img class="float-md-start mb-0" src="/assets/ccs.webp" alt="Care Coordination Systems" />
    </div>
  </header>

  <main>
    <div class="center">
      <h1>Welcome to the {{ title }}</h1>
      <p>Bringing together the information and management resources you need to implement and track your clients' progress.</p>
      <ng-container>
        <p>
          @if(!isAuthenticated){
          <button matButton="filled" (click)="signIn()">Sign In</button>
          }
          @else{
          <mat-progress-bar mode="indeterminate"></mat-progress-bar>
          }
        </p>
      </ng-container>     
    </div>
  </main>

  <footer>
    <div>
      {{ footer }}
    </div>
  </footer>
</div>
